export enum CampaignType {
  MAIN_PAGE = 'MainPage',
  HOTEL = 'Hotel',
  TOUR = 'Tour',
  FLIGHT = 'Flight',
}
